<template>
  <DialogDrawer
    ref="dialog"
    data-testid="feedback-dialog"
    placement="right"
    modal
    dismissible
    class="h-100"
    @close="close"
  >
    <template #title>{{ translate('Give Feedback to Ekco') }}</template>

    <FeedbackForm ref="form" :context="context" />

    <template #buttons>
      <BootstrapButton
        v-if="form?.submitted"
        name="close-button"
        variant="primary"
        data-testid="feedback.form.button.close"
        @click="close"
      >
        {{ translate('Close') }}
      </BootstrapButton>
      <template v-else>
        <BootstrapButton
          name="cancel-button"
          variant="secondary"
          data-testid="feedback.form.button.cancel"
          @click="close"
        >
          {{ translate('Cancel') }}
        </BootstrapButton>
        <BootstrapButton
          name="submit-button"
          type="submit"
          form="feedback-form"
          :disabled="form?.loading"
          :loading="form?.loading"
          data-testid="feedback.form.button.send"
        >
          {{ translate('Send to Ekco') }}
        </BootstrapButton>
      </template>
    </template>
  </DialogDrawer>
</template>
<script setup>
import {useLocalisation} from '@/composables/useLocalisation';
import FeedbackForm from './FeedbackForm.vue';

/**
 * The feedback form in a drawer. Within Sphere it is a page of the settings instead (see
 * SendFeedbackView), this is for where there are no settings: when Sphere failed to load.
 */
const emits = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  // Why Sphere failed to load, if it did: it is sent with the feedback
  context: {
    type: String,
    default: undefined,
  },
});

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
});

const {translate} = useLocalisation();

const dialog = ref();
const form = ref();

const close = () => {
  dialog.value?.close();
  model.value = false;
  form.value?.reset();
};

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      dialog.value?.openModal();
    } else {
      dialog.value?.close();
    }
  },
);
</script>
